import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { LoaderService } from '../../../shared/services/loader.service';
import { ContactRequest } from '../models/contact-request';
import { NotificationService } from '../../../shared/services/notification.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contact',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent implements OnInit {

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private loader: LoaderService,
    private notificationService: NotificationService,
    private route: ActivatedRoute
  ) {
    this.form = this.fb.group({
      nombre:['', Validators.required],
      telefono:['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      opinion: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    const uuidc = this.route.snapshot.queryParams['uuidc'];
    if (uuidc && ['2228', '2665', '2559', '2907', '2988'].includes(uuidc)) {
      localStorage.setItem('uuidClient', uuidc);
    }
  }

  submit() {

    this.loader.show();

    if (this.form.valid) {
      const payload : ContactRequest = {
        identifier: {
          tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
          app: 'PortalAsistencia',
        },
        petition: {
          email: this.form.value.email,
        },
      };

      //request
    }
    
    setTimeout(()=>{
      this.loader.hide()}
    , 900);
    setTimeout(()=>{
      this.notificationService.showSuccess('Sus datos han sido enviados con éxito, pronto estaremos en contacto con usted.','Contacto enviado');
    }, 1000)


  }


}
